import Vue from 'vue'
import Router from 'vue-router'

/* IMPORT DES VUES */
import LoginView from './views/LoginView.vue'
import SearchView from './views/SearchView.vue'
import ProductView from './views/ProductView.vue'
import BasketView from './views/BasketView.vue'
import SendView from './views/SendView.vue'

/* IMPOR DU STORE */
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login-view',
      component: LoginView
    },
    {
      path: '/',
      name: 'search-view',
      component: SearchView,
      meta: { requiresAuth: true }
    },
    {
      path: '/products/view/:id',
      name: 'product-view',
      component: ProductView,
      meta: { requiresAuth: true }
    },
    {
      path: '/basket',
      name: 'basket-view',
      component: BasketView,
      meta: { requiresAuth: true }
    },
    {
      path: '/send',
      name: 'send-view',
      component: SendView,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // check if the route requires authentication and user is not logged in
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
      // redirect to login page
      next({ name: 'login-view' })
      return
  }

  // if logged in redirect to dashboard
  if(to.path === '/login' && store.state.isLoggedIn) {
      next({ name: 'search-view' })
      return
  }

  next()
})

export default router